import {Component, EventEmitter, Input, Output} from '@angular/core';
import {LocalStorageService} from "ngx-webstorage";
import {DirectoryModel} from "../directory/service/directory.model";

@Component({
  selector: 'app-left-slider',
  templateUrl: './slider.component.html'
})
export class SliderComponent {
  user: DirectoryModel;

  @Input()
  statusBar: boolean;
  @Output('closeMenuEvent')
  closeMenuEvent: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(private localSt: LocalStorageService,) {
    this.user = localSt.retrieve('usr-ss');
  }

  /**
   * Validación de roles a ver la opción.
   * @param rols: Array
   */
  validateRole(rols: any[]) {
    return true;
  }

  /**
   * Ocultar menu.
   */
  closeMenu() {
    this.closeMenuEvent.emit(false);
  }

  deleteUserSession() {
    this.localSt.clear('usr-ss');
  }
}




// WEBPACK FOOTER //
// ./src/app/base-component/slider.component.ts